export const FIXED_FOOTER_ID = 'fixed_footer';
